<template>
  <div class="main">
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun"
          >查询</Button
        ></template
      ></selectTool
    >

    <Table
      row-key="id"
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(260)"
      @on-row-click="$emit('obj', $event)"
      @on-selection-change="selectData = $event"
    >
      <AddressList
        slot-scope="{ row, index }"
        slot="pickupAddress"
        :list="row.pickupAddress"
        :readonly="true"
        :noUpdate="true"
      ></AddressList>
      <AddressList
        slot-scope="{ row, index }"
        slot="unloadAddress"
        :list="row.unloadAddress"
        :readonly="true"
        :noUpdate="true"
      ></AddressList>
    </Table>
    <div id="mypage">
      <Button v-if="checkMore" @click="$emit('objs', selectData)" type="success"
        >我选好了</Button
      >
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增订单基本信息' : '编辑订单基本信息'"
      width="1200"
      fullscreen
      ref="formModel"
    >
      <tableForm
        slot="ordersGoodsList"
        ref="ordersGoodsList"
        height="200"
        :forms="ordersGoodsListForm"
        :item1="ordersGoodsListItem"
        v-model="item.ordersGoodsList"
      >
      </tableForm>
      <tableForm
        slot="ordersChargesList"
        ref="ordersChargesList"
        height="200"
        :forms="ordersChargesListForms"
        :item1="ordersChargesListItem"
        v-model="item.ordersChargesList"
      >
        <Button type="primary" slot="btns" @click="getTempList"
          >计算费用</Button
        >
      </tableForm>
      <tableForm
        slot="ordersUnGoodsList"
        ref="ordersUnGoodsList"
        height="200"
        :forms="ordersUnGoodsListForms"
        :item1="ordersUnGoodsListItem"
        v-model="item.ordersUnGoodsList"
      >
      </tableForm>
      <tableForm
        slot="ordersCustomsList"
        ref="ordersCustomsList"
        height="200"
        :forms="ordersCustomsListForms"
        :item1="ordersCustomsListItem"
        v-model="item.ordersCustomsList"
      >
      </tableForm>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <form-model title="更新订单状态" width="400" ref="renwuzhuangtai">
      <Button slot="btn" type="primary" @click="updateStatus">确定更新</Button>
    </form-model>
    <form-model title="退货处理" width="500" ref="tuihuoFormModel">
      <Button slot="btn" type="primary" @click="tuihuo">确定退货</Button>
    </form-model>
  </div>
</template>
<script>
var list1 = [],
  list2 = [];
var kehuitems = [];
import tableWrap from "../../common/tableWrap.vue";
export default {
  components: { tableWrap },
  props: ["scan", "checkMore", "status", "col"],
  data() {
    return {
      isAdd: false,
      openForm: false,
      openYundan: false,
      columns: [
        {
          type: "selection",
          width: 70,
          align: "center",
          tooltip: true,
          noTable: this.checkMore != true,
        },
        /*  {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        }, 
        {
          type: "expand",
          width: 50,
          align: "center",
          render: (h, data) => {
            return h(tableWrap, {
              //局部注册组件不需要加引号
              props: {
                //tableList: data.row.pickupAddressList,
                tableList: [
                  {
                    columns: this.ordersGoodsListForm,
                    tableData: data.row.ordersGoodsList,
                  },
                  {
                    columns: this.ordersUnGoodsListForms,
                    tableData: data.row.ordersUnGoodsList,
                  },
                  {
                    columns: this.ordersChargesListForms,
                    tableData: data.row.ordersChargesList,
                  },
                  {
                    columns: this.ordersCustomsListForms,
                    tableData: data.row.ordersCustomsList,
                  },
                ],
              },
            });
          },
        },*/
        {
          title: "订单编号",
          minWidth: 180,
          key: "no",
          tree: true,
          sort: 0,
        },
        /* {
          title: "客户单号",
          minWidth: 180,
          key: "customerNo",
          sort: 2,
        }, */
        {
          title: "订单状态",
          minWidth: 130,
          key: "status2",
          sort: 0,
        },
      ],
      tableData: [],
      item: {
        xd: 0,
        xs: 0,
        yd: 0,
        ys: 0,
        groupId: "",
        groupName: "",
        no: "",
        cid: "",
        customer: "",
        customerNo: "",
        carType: "3T吨车",
        contractNo: "",
        addressS: "",
        addressD: "",
        bpMode: 1,
        payMode: "转账",
        deliveryMode: "派送",
        tradeType: "",
        recevieModel: "上门取货",
        sendTime: Date.now() + 86400000,
        salemanId: "",
        shipmentTime: Date.now() + 86400000,
        saleman: "",
        isTransfers: true,
        releaseAsk: "",
        currency: "人民币",
        sealNo: "",
        cabinetNo: "",
        isTax: true,
        taxRate: 0,
        exchangeRate: 0,
        remark: "",
        //extendFields: "",
        //filesPath: "",
        ordersGoodsList: [],
        ordersUnGoodsList: [],
        ordersChargesList: [],
        ordersCustomsList: [],
      },

      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        startTime: "",
        endTime: "",
        no: "",
        keyWork: "",
        customer: "",
        customerNo: "",
        addressD: "",
        addressS: "",
        //status: 0, //订单状态(0 订单确认，1 上门提货 2 提货已完成，3-待配载,4- 已配载 5-待发车，6-已发车，7 在途中，8 已过关，9 已送达香港仓库,10 同城配送, 11未签收,12 已签收,13 客户退货)
        //bpMode: true,
        carType: "",
        tradeType: "",
        deliveryMode: "",
        //status:[0,1,2,3,4,5]
      },
      searchForms: [
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
        {
          title: "订单状态",
          key: "status",
          required: true,
          multiple: true,
          span: 8,
          type: "Select",
          selectItems: this.lydic["orderStatus"],
          selectType: "obj",
        },
        {
          title: "客户名称",
          key: "cid",
          key2: "customer",
          required: true,
          span: 8,
          type: "Select",
          selectItems: kehuitems,
          selectType: "obj",
          fenlei: "基本信息",
        },
        {
          title: "贸易方式",
          key: "tradeType",
          required: false,
          type: "Select",
          selectItems: this.lydic["tradeType"],
        },
        {
          title: "车辆类型",
          key: "carType",
          required: false,
          type: "Select",
          selectItems: this.lydic.getA("cartype"),
        },
        {
          title: "始发地",
          key: "addressS",
          required: false,
          type: "Select",
          selectItems: this.lydic.getA("addressPrice"),
        },
        {
          title: "目的地",
          key: "addressD",
          required: false,
          type: "Select",
          selectItems: this.lydic.getA("addressPrice"),
        },
        {
          title: "交货方式",
          key: "deliveryMode",
          required: false,
          type: "Select",
          selectItems: ["派送", "提货", "自提", "自送", "存仓"],
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
      total: 0,
      categorys: [],
      forms: [
        {
          title: "客户名称",
          key: "cid",
          key2: "customer",
          required: true,
          span: 4,
          type: "Select",
          selectItems: kehuitems,
          selectType: "obj",
          fenlei: "基本信息",
        },
        /* {
          title: "客户单号",
          key: "customerNo",
          required: false,
          span: 8,
          type: "Input",
          fenlei: "基本信息",
        }, */
        {
          title: "车辆类型",
          key: "carType",
          required: true,
          span: 4,
          type: "Select",
          selectItems: this.lydic.getA("cartype"),
          fenlei: "基本信息",
        },

        {
          title: "始发地",
          key: "addressS",
          keyX: "xs",
          keyY: "ys",
          required: true,
          type: "Select",
          selectItems: this.lydic.getA("addressPrice"),
          span: 4,
          fenlei: "基本信息",
        },
        {
          title: "目的地",
          key: "addressD",
          keyX: "xd",
          keyY: "yd",
          required: true,
          type: "Select",
          selectItems: this.lydic.getA("addressPrice"),
          span: 4,
          fenlei: "基本信息",
        },
        {
          title: "业务类型",
          key: "bpMode",
          key2: "bpMode2",
          required: true,
          span: 4,
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["bpMode"],
          fenlei: "基本信息",
        },
        {
          title: "支付方式",
          key: "payMode",
          required: true,
          span: 4,
          type: "Select",
          selectItems: ["转账", "支票", "现金"],
          fenlei: "基本信息",
        },
        {
          title: "交货方式",
          key: "deliveryMode",
          required: true,
          span: 4,
          type: "Select",
          selectItems: ["派送", "提货", "自提", "自送", "存仓"],
          filterable: true,
          allowCreate: true,
          fenlei: "基本信息",
        },
        {
          title: "贸易类型",
          key: "tradeType",
          required: true,
          span: 4,
          type: "Select",
          selectItems: this.lydic.tradeType,
          fenlei: "基本信息",
        },
        {
          title: "收货方式",
          key: "recevieModel",
          required: true,
          span: 4,
          type: "Select",
          selectItems: ["上门取货", "自提", "自送"],
          fenlei: "基本信息",
        },
        {
          title: "业务员",
          key4: "salemanId",
          key1: "saleman",
          required: true,
          span: 4,
          type: "selectUser",
          fenlei: "基本信息",
        },
        {
          title: "是否中转",
          key: "isTransfers",
          key2: "isTransfers2",
          required: false,
          span: 4,
          type: "bool",
          fenlei: "基本信息",
        },
        {
          title: "送货时间",
          key: "sendTime",
          key2: "sendTime2",
          required: true,
          span: 6,
          width: 130,
          type: "lyyymmdd",
          formate: "datetime",
          fenlei: "基本信息",
        },

        {
          title: "装货时间",
          key: "shipmentTime",
          key2: "shipmentTime2",
          required: true,
          span: 6,
          width: 130,
          type: "lyyymmdd",
          formate: "datetime",
          fenlei: "基本信息",
        },

        {
          title: "放货要求",
          key: "releaseAsk",
          required: false,
          span: 4,
          type: "Input",
          fenlei: "基本信息",
        },
        {
          title: "币别",
          key: "currency",
          required: false,
          span: 4,
          type: "Select",
          selectItems: this.lydic.getA("mType"),
          fenlei: "基本信息",
        },
        {
          title: "封条号",
          key: "sealNo",
          required: false,
          span: 4,
          type: "Input",
          fenlei: "基本信息",
        },
        {
          title: "柜号",
          key: "cabinetNo",
          required: false,
          type: "Input",
          span: 4,
          fenlei: "基本信息",
        },
        {
          title: "是否含税",
          key: "isTax",
          key: "isTax2",
          required: false,
          span: 4,
          type: "bool",
          fenlei: "基本信息",
        },
        {
          title: "税率",
          key: "taxRate",
          required: false,
          span: 4,
          type: "InputNumber",
          fenlei: "基本信息",
        },
        {
          title: "汇率",
          key: "exchangeRate",
          required: false,
          span: 4,
          type: "InputNumber",
          fenlei: "基本信息",
        },
        {
          title: "备注信息",
          key: "remark",
          required: false,
          span: 4,
          type: "Input",
          fenlei: "基本信息",
        },
        /* {
          title: "附件路径",
          key: "filesPath",
          required: false,
          span:8,
          type: "lyPhoto",
          fenlei: "基本信息",
        }, */
        {
          title: "订单提货",
          key: "ordersGoodsList",
          slotForm: "ordersGoodsList",
          required: true,
          noTable: true,
          type: "Input2",
          fenlei: "基本信息",
          span: 24,
        },
        {
          title: "订单卸货",
          key: "ordersUnGoodsList",
          slotForm: "ordersUnGoodsList",
          required: false,
          noTable: true,
          type: "Input2",
          fenlei: "基本信息",
          span: 24,
        },
        {
          title: "报关信息",
          key: "ordersCustomsList",
          slotForm: "ordersCustomsList",
          required: true,
          noTable: true,
          hideLabel: false,
          type: "Input2",
          fenlei: "基本信息",
          span: 24,
        },
        {
          title: "收费项目",
          key: "ordersChargesList",
          slotForm: "ordersChargesList",
          required: true,
          noTable: true,
          hideLabel: false,
          type: "Input2",
          fenlei: "基本信息",
          span: 24,
        },
      ],
      ordersGoodsListForm: [
        {
          title: "提货名称",
          key: "name",
          required: true,
          val: "",
          type: "Input",
        },
        {
          title: "提货时间",
          key: "pickupTime",
          required: false,
          type: "lyyymmdd",
        },
        /* {
          title: "提货工厂",
          key: "pickupFactory",
          required: false,
          type: "Input",
        }, */
        {
          title: "提货地址",
          key: "pickupAddress",
          required: false,
          width: 300,
          type: "AddressList",
          list1: list1,
          list2: list2,
        },

        /*  {
          title: "型号",
          key: "model",
          required: false,
          val: "",
          type: "Input",
        }, */
        {
          title: "卡板数P/L",
          key: "pnumber",
          required: false,
          type: "InputNumber",
        },
        {
          title: "数量/件",
          key: "amount",
          required: false,
          val: 0,
          type: "InputNumber",
        },
        {
          title: "重量/kgs",
          key: "weight",
          required: false,
          val: 0,
          type: "InputNumber",
        },
        {
          title: "体积/cbm",
          key: "volume",
          required: false,
          val: 0,
          type: "InputNumber",
        },

        {
          title: "联系人",
          key: "contact",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "电话",
          key: "tel",
          required: false,
          val: "",
          type: "Input",
        },
        /* {
          title: "条形码",
          key: "barCode",
          required: false,
          type: "Input",
        }, */
        {
          title: "备注",
          key: "remark",
          required: false,
          val: "",
          type: "Input",
        },
      ],
      ordersGoodsListItem: {
        pnumber: 0,
        //id: 0,
        //pageNumber: 0,
        //pageSize: 0,
        pickupTime: Date.now() + 86400000, //提货时间
        name: "手机",
        pickupFactory: "", //提货工厂
        barCode: "",
        pickupAddress: [], //提货地址
        contact: "",
        volume: 1,
        model: "",
        tel: "",
        amount: 1,
        weight: 1,
        //imgPath: "",
        remark: "",
        keyWork: "",
        //idList: [],
      },
      ordersChargesListForms: [
        {
          title: "收付项目",
          key: "name",
          type: "Input",
          required: true,
        },
        {
          title: "标签",
          key: "lable",
          type: "Input",
          required: true,
        },
        {
          title: "应收金额",
          key: "receiveAmount",
          type: "InputNumber",
          required: true,
        },
        {
          title: "应付金额",
          key: "payAmount",
          type: "InputNumber",
          required: true,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
        },
      ],
      ordersChargesListItem: {
        //id: 0,
        name: "111",
        lable: "始发地费用", //	标签(始发地费用，目的地费用)
        receiveAmount: 0, //应收金额
        payAmount: 0, //应付金额
        remark: "",
        //keyWork: "",
        //idList: [],
      },

      ordersUnGoodsListForms: [
        {
          title: "卸货名称",
          key: "name",
          required: true,
          type: "Input",
        },
        {
          title: "卸货公司",
          key: "receiveCompany",
          required: false,
          type: "Input",
        },
        {
          title: "卸货地址",
          key: "receiveAddress",
          required: false,
          width: 300,
          type: "AddressList",
          list1,
          list2,
        },
        {
          title: "联系人",
          key: "contact",
          required: false,
          type: "Input",
        },
        {
          title: "电话",
          key: "tel",
          required: false,
          type: "Input",
        },
        {
          title: "单位",
          key: "unit",
          required: false,
          type: "Input",
        },
        {
          title: "分类",
          key: "category",
          required: true,
          type: "Input",
        },
        {
          title: "唛头",
          key: "mark",
          required: false,
          type: "Input",
        },
        {
          title: "包装",
          key: "packing",
          required: false,
          type: "Input",
        },
        {
          title: "体积/cbm",
          key: "volume",
          required: false,
          type: "InputNumber",
        },
        {
          title: "重量/kgs",
          key: "weight",
          required: false,
          type: "InputNumber",
        },
        {
          title: "长度/cm",
          key: "length",
          required: false,
          type: "Input",
        },
        {
          title: "宽度/cm",
          key: "wide",
          required: false,
          type: "Input",
        },
        {
          title: "高度/cm",
          key: "high",
          required: false,
          type: "Input",
        },
        {
          title: "数量/件",
          key: "amount",
          required: false,
          type: "InputNumber",
        },
        {
          title: "备注",
          key: "remark",
          required: false,
          type: "Input",
        },
      ],
      ordersUnGoodsListItem: {
        pnumber: 1, //卡板数量
        name: "",
        mark: "",
        packing: "",
        category: "",
        unit: "",
        receiveCompany: "",
        contact: "",
        tel: "",
        receiveAddress: [],
        volume: 0,
        weight: 0,
        length: "",
        wide: "",
        high: "",
        amount: 1,
        remark: "",
      },

      ordersCustomsListForms: [
        /* {
          title: "订单号",
          key: "ono",
          required: false,
          type: "Select",
          selectItems: ["TN334566445", "TN3345664454"],
        }, */
        {
          title: "贸易类型",
          key: "tradeType",
          required: false,
          type: "Select",
          selectItems: ["进口", "出口"],
        },
        {
          title: "报关类型",
          key: "bgType",
          required: false,
          type: "Select",
          selectItems: ["报关", "清关", "舱单"],
        },
        {
          title: "报关方式",
          key: "mode",
          required: false,
          type: "Select",
          selectItems: ["电子报关", "客人自提", "代理报关"],
        },
        {
          title: "进出口岸",
          key: "ckPort",
          required: false,
          type: "Select",
          selectItems: this.lydic.getA("port"),
        },
        {
          title: "报关员",
          key: "bgPerson",
          required: false,
          type: "Input",
        },
        {
          title: "电话",
          key: "tel",
          required: false,
          type: "Input",
        },
        {
          title: "无缝号码",
          key: "wfNo",
          required: false,
          type: "Input",
        },
        {
          title: "文件数量",
          key: "filesNum",
          required: false,
          type: "InputNumber",
        },
        /* {
          title: "进口口岸",
          key: "jkPort",
          required: false,
          type: "Select",
          selectItems: this.lydic.getA("port"),
        }, */
        {
          title: "清关公司",
          key: "qgCompany",
          required: false,
          type: "Input",
        },

        {
          title: "清关号码",
          key: "qgNo",
          required: false,
          type: "Input",
        },
        {
          title: "六联单号",
          key: "sixNo",
          required: false,
          type: "Input",
        },
        {
          title: "备注信息",
          key: "remark",
          required: false,
          type: "Input",
        },
      ],
      ordersCustomsListItem: {
        tradeType: "",
        bgType: "",
        mode: "",
        ckPort: "",
        bgPerson: "",
        wfNo: "",
        tel: "",
        filesNum: 0,
        jkPort: "",
        qgCompany: "",
        qgAddress: "",
        qgNo: "",
        sixNo: "",
        remark: "",
      },

      updateStatusItem: {
        status: 0,
      },
      updateStatusForms: [
        {
          title: "运单状态",
          key: "status",
          required: true,
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["orderStatus"], //
          span: 24,
        },
      ],
      selectData: [],
      tuihuoItem: {
        ono: "",
        tno: "",
        storeNo: "",
        remark: "",
      },
      tuihuoForms: [
        {
          title: "订单号",
          key: "ono",
          type: "Input",
          readonly: true,
          required: true,
        },

        {
          title: "入仓号",
          key: "storeNo",
          required: false,
          type: "Input",
        },
        {
          title: "备注信息",
          key: "remark",
          required: false,
          type: "Input",
        },
      ],
      temItem: {
        cid: 0,
        addressS: "",
        addressD: "",
        bpMode: 0,
        carType: "",
        weight: 0,
        volume: 0,
      },
      //
      ca: {
        weight: 0,
        volume: 0,
        pnumber: 0,
      },
    };
  },
  methods: {
    getList() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/listSort",

        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i]._showChildren=true;
          data[i].sendDate2 = this.utils.time(data[i].sendDate, "yymmdd");
          data[i].isTax2 = this.$t("bool." + data[i].isTax);
          data[i].isTransfers2 = this.$t("bool." + data[i].isTransfers);
          data[i].bpMode2 = this.lydic.getVal("bpMode", data[i].bpMode);
          data[i].shipmentTime2 = this.utils.time(
            data[i].shipmentTime,
            "yymmddhhmm"
          );
          data[i].sendTime2 = this.utils.time(data[i].sendTime, "yymmddhhmm");
          data[i].status2 = this.lydic.getVal("orderStatus", data[i].status);
          for (let j = 0; j < data[i].ordersFdpzList.length; j++) {
            data[i].ordersFdpzList[j].status2 = this.lydic.getVal(
              "orderStatus",
              data[i].ordersFdpzList[j].status
            );
          }
          data[i].children = data[i].ordersFdpzList;
          data[i]._disabled = data[i].ordersFdpzList.length > 0 ? true : false;
          data[i].pickupAddress = pick(data[i].ordersGoodsList);
          data[i].unloadAddress = unLoad(data[i].ordersUnGoodsList);

          var t = data[i].ordersGoodsList;
          var pnumber = 0,
            amount = 0,
            weight = 0,
            volume = 0,
            pnumbers = [],
            amounts = [],
            weights = [],
            volumes = [],
            name = [];
          for (let j = 0; j < t.length; j++) {
            pnumber += t[j].pnumber;
            weight += t[j].weight;
            volume += t[j].volume;
            amount += t[j].amount;
            pnumbers.push(t[j].pnumber);
            amounts.push(t[j].amount);
            weights.push(t[j].weight);
            volumes.push(t[j].volume);
            name.push(t[j].name);
            t[j].pickupTime2 = this.utils.time(t[j].pickupTime, "yymmddhhmm");
          }
          data[i].pnumber = pnumber;
          data[i].amount = amount;
          data[i].weight = weight;
          data[i].volume = volume;

          data[i].pnumbers = pnumbers;
          data[i].amounts = amounts;
          data[i].weights = weights;
          data[i].volumes = volumes;

          data[i].name = name.join(",");
          var t = data[i].ordersCustomsList;
          var ports = [];
          for (let j = 0; j < t.length; j++) {
            if (!ports.includes(t[j].ckPor)) {
              ports.push(t[j].ckPort);
            }
          }
          data[i].ports = ports;
        }
        function pick(v) {
          var arr = [];
          for (let i = 0; i < v.length; i++) {
            var t = v[i].pickupAddress;
            for (let j = 0; j < t.length; j++) {
              arr.push(t[j]);
            }
          }

          return arr;
        }
        function unLoad(v) {
          var arr = [];

          for (let i = 0; i < v.length; i++) {
            var t = v[i].receiveAddress;
            for (let j = 0; j < t.length; j++) {
              arr.push(t[j]);
            }
          }
          return arr;
        }
        function cacu(v, type) {
          var pnumber = 0,
            amount = 0;
          for (let i = 0; i < v.length; i++) {
            pnumber += v[i].pnumber;
            amount += v[i].amount;
          }
        }
        this.tableData = data;
      });
    },

    addUpdate(name) {
      var table = this.$refs.ordersGoodsList.yanzheng();
      if (table != true) {
        this.$Message.error(table);
        return;
      }
      var table = this.$refs.ordersChargesList.yanzheng();
      if (table != true) {
        this.$Message.error(table);
        return;
      }
      var table = this.$refs.ordersUnGoodsList.yanzheng();
      if (table != true) {
        this.$Message.error(table);
        return;
      }
      var table = this.$refs.ordersCustomsList.yanzheng();
      if (table != true) {
        this.$Message.error(table);
        return;
      }
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      var aaa = this.utils.findObj(kehuitems, "id", a.cid);
      this.item.customer = aaa.name;

      /*  var b = this.$refs.ordersGoodsList.yanzheng("货物项目");
      var c = this.$refs.ordersChargesList.yanzheng("收费项目");
      
      if (!(b && c)) {
        return;
      } */

      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-omc/orders/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-omc/orders/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-omc/orders/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    opemTuihuo(row) {
      console.log(row);
      this.tuihuoItem.ono = row.no;
      //this.item = JSON.parse(JSON.stringify(row));
      this.$refs.tuihuoFormModel.reach(this.tuihuoForms, this.tuihuoItem);
    },
    tuihuo(name) {
      var a = this.$refs.tuihuoFormModel.getItem();
      if (!a) {
        return;
      }
      this.tuihuoItem = a;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/back/add",
        data: this.tuihuoItem,
      }).then((res) => {
        if (res) {
          this.$refs.tuihuoFormModel.close();
          this.$Message.success("退货成功");
        }
      });
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    //卡板数，重量，体积计算器
    caculate() {
      this.ca.volume = 1;
      this.ca.pnumber = 1;
      this.ca.weight = 1;
      var canshu = {
        cid: this.item.cid,
        addressS: this.item.addressS,
        addressD: this.item.addressD,
        bpMode: this.item.bpMode,
        carType: this.item.carType,
        ...this.ca,
      };
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-base/costTemplet/businessTypeCheck",
        data: canshu,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        console.log(res);
      });
    },
    getTempList() {
      this.caculate();
      var canshu = {
        cid: this.item.cid,
        addressS: this.item.addressS,
        addressD: this.item.addressD,
        bpMode: this.item.bpMode,
        carType: this.item.carType,
        ...this.ca,
      };
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-base/costTemplet/listCostItemMatch",
        data: canshu,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        var data = res.data.data;
        for (let i = 0; i < this.forms.length; i++) {
          if (this.forms[i].key == "ordersChargesList") {
            //alert(this.forms[j].key)
            this.item[this.forms[i].key] = data;
          }
        }
      });
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    kehuliebiao() {
      kehuitems.splice(0, 1000);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
          kehuitems.push(obj);
        }
      });
    },
    openUpdateStatus(row) {
      this.updateStatusItem.status = row.status;
      this.updateStatusItem.no = row.no;

      this.$refs.renwuzhuangtai.reach(
        this.updateStatusForms,
        this.updateStatusItem
      );
    },
    updateStatus() {
      var a = this.$refs.renwuzhuangtai.getItem();
      if (!a) {
        return;
      }
      this.updateStatusItem = a;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/updateStatus",
        data: this.updateStatusItem,
      }).then((res) => {
        console.log(res);
        if (res) {
          this.$refs.renwuzhuangtai.close();
          this.getList();
        }
      });
    },
    getKehuItem() {
      return;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/info",
        data: { id: this.item.cid },
      }).then((res) => {
        console.log(res);
        var pickupAddressList = res.data.data.pickupAddressList;
        var shippingAddressList = res.data.data.shippingAddressList;
        list1.splice(0, 1000);
        list2.splice(0, 1000);
        for (let i = 0; i < pickupAddressList.length; i++) {
          var add = pickupAddressList[i].address.split("_");

          var obj = {
            name: add[0],
            address: add[1],
            x: pickupAddressList[i].x,
            y: pickupAddressList[i].y,
          };
          list1.push(obj);
        }
        for (let i = 0; i < shippingAddressList.length; i++) {
          var add = shippingAddressList[i].address.split("_");
          var obj = {
            name: add[0],
            address: add[1],
            x: shippingAddressList[i].x,
            y: shippingAddressList[i].y,
          };
          list2.push(obj);
        }
      });
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 200,
    };
    if (this.col) {
      this.forms = this.col;
    }
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.kehuliebiao();
    if (this.status) {
      this.searchItem.status = this.status;
    }
  },
  computed: {
    cid() {
      return this.item.cid;
    },
  },
  watch: {
    cid(v) {
      this.getKehuItem();
    },
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/xitongkaidanSort.vue